export class ManagementService {
  constructor (API, Auth) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
  }

  getAvailableSelections() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog/managementReport/availableSelections'
    });
  }

  getManagementReport(fromDate, toDate, teams) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog/managementReport',
      responseType: 'blob',
      params: {
        from: fromDate,
        to: toDate,
        teamId: teams
      }
    });
  }
}